<template>
<div v-if="show" class="gallery-modal-overlay" @click="$event.target == $event.currentTarget && close()">
    <div class="gallery-modal" @click="$event.target == $event.currentTarget && close()">
        <button class="btn btn-close gallery-modal__close" @click="close()">
            <svg class="svg-icon svg-icon-close icon-32"><use xlink:href="/img/symbol-defs.svg#svg-icon-close"></use></svg>
        </button>
        <div class="swiper-container gallery-modal__main">
            <div class="swiper-wrapper gallery-modal__main-slides">
                <div class="swiper-slide gallery-modal__main-slide" v-for="(item, index) in items" :key="index">
                    <img v-if="item.href && !item.youtube" :src="item.href">
                    <div v-if="item.youtube" class="embed-responsive embed-responsive-16by9">
                        <iframe id="ytplayer" class="embed-responsive-item" type="text/html" :src="'https://www.youtube.com/embed/'+item.youtube+'?autoplay=1&rel=0'" frameborder="0" />
                    </div>
                    <div class="gallery-modal__main-title" v-if="item.title">{{item.title}}</div>
                </div>
            </div>
            <div v-if="items.length > 1" class="gallery-modal__main-nav gallery-modal__main-nav_prev">
                <svg class="svg-icon svg-icon-arrow-left icon-32"><use xlink:href="/img/symbol-defs.svg#svg-icon-arrow-left"></use></svg>
            </div>
            <div v-if="items.length > 1" class="gallery-modal__main-nav gallery-modal__main-nav_next">
                <svg class="svg-icon svg-icon-arrow-right icon-32"><use xlink:href="/img/symbol-defs.svg#svg-icon-arrow-right"></use></svg>
            </div>
        </div>
        <div v-if="enableThumbnails" class="swiper-container gallery-modal__thumbs">
            <div class="swiper-wrapper gallery-modal__thumbs-slides">
                <div class="swiper-slide gallery-modal__thumbs-slide" v-for="item in items" :key="item.thumbnail">
                    <img :src="item.thumbnail">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Swiper from 'swiper/dist/js/swiper.js'; // https://github.com/nolimits4web/swiper/issues/2263#issuecomment-339919428
import 'swiper/dist/css/swiper.css';

export default {
    data() {
        return {
            show: false
        };
    },
    methods: {
        close() {
            this.show = false;
            this.$emit('close');
            window.removeEventListener('keyup', this.onKeyUp);
            if (this.galleryThumbs) {
                this.galleryThumbs.destroy();
                delete this.galleryThumbs;
            }
            if (this.galleryMain) {
                this.galleryMain.destroy();
                delete this.galleryMain;
            }
        },
        open(index) {
            index = index || 0;
            this.show = true;
            this.$nextTick(() => {
                if (this.enableThumbnails) {
                    this.galleryThumbs = new Swiper('.gallery-modal__thumbs', {
                        spaceBetween: 6,
                        slidesPerView: 'auto',
                        freeMode: true,
                        watchSlidesVisibility: true,
                        watchSlidesProgress: true,
                    });
                }
                this.galleryMain = new Swiper('.gallery-modal__main', {
                    loop: true,
                    spaceBetween: 1000,
                    keyboard: {
                        enabled: true,
                    },
                    navigation: {
                        nextEl: '.gallery-modal__main-nav_next',
                        prevEl: '.gallery-modal__main-nav_prev',
                        disabledClass: 'gallery-modal__main-nav_disabled'
                    },
                    thumbs: {
                        swiper: this.galleryThumbs,
                        slideThumbActiveClass: 'gallery-modal__thumbs-slide_active',
                    },
                    initialSlide: index,
                });
                // this.slideTo(index);

                swipedetect($('.swiper-wrapper')[0], direction => {
                    if (direction == 'down') {
                        this.$emit('close');
                    }
                });
            });
            window.addEventListener('keyup', this.onKeyUp);
        },
        isOpened() {
            return !!this.galleryMain;
        },
        slideTo(index) {
            this.galleryMain.slideTo(index);
        },
        onKeyUp(e) {
            e.keyCode == 27 && this.close(); // Esc
        }
    },
    props: ['index','items','enableThumbnails'],
    watch: {
        'index': function (val, oldVal) {
            // console.log('watch index', val);
            if (val !== null) {
                if (this.isOpened()) {
                    this.slideTo(val);
                } else {
                    this.open(val);
                }
            } else {
                this.close();
            }
        }, 
        'items': function (val, oldVal) {
            // console.log('watch items', val);
            if (val === null || val.length == 0) {
                this.close();
            }
        }
    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style>
    
</style>